import { connect } from "react-redux";
import * as usersActions from "../actions";

function mapStateToProps(state) {
  return {
    accountInfos: state.users.accountInfos,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAccountInfoForId: (accountId) => {
      dispatch(usersActions.get_user_data_for_account_id(accountId));
    },
  };
}

const accountInfosConnector = connect(mapStateToProps, mapDispatchToProps);
export default accountInfosConnector;
